var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"news"}},[_c('div',{staticClass:"row-nowrap"},[_c('div',{attrs:{"id":"subject-news-body"}},_vm._l((_vm.newsList),function(item){return _c('div',{key:item.id},[_c('div',{staticClass:"news-item",on:{"click":function($event){return _vm.goToDetail(item.id)}}},[_c('div',{staticClass:"row-nowrap",style:({
              display: 'flex',
              border:
                _vm.showBorder == 2
                  ? '2px solid #FFF'
                  : _vm.showBorder == 1
                  ? '2px solid #000'
                  : '0px',
            })},[_c('div',{staticStyle:{"width":"120px","height":"67px"}},[_c('img',{staticStyle:{"width":"120px","height":"67px"},attrs:{"src":_vm.getImageURL(_vm.parseUrl(item.cover)[0])}})]),_c('div',{staticClass:"news-text"},[_c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(item.title))])])])])])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }